import React from 'react';
import PropTypes from 'prop-types';
import {Text, Container, IconContainer} from './icon_text';

// searchString and value is used by nested Dropdown
// eslint-disable-next-line no-unused-vars
export const IconTextIcon = ({children, searchString, value, text}) => {
	return (
		<Container>
			<IconContainer>{children[0]}</IconContainer>
			<Text>{text}</Text>
			<IconContainer>{children[1]}</IconContainer>
		</Container>
	);
};

IconTextIcon.propTypes = {
	children: PropTypes.arrayOf(PropTypes.element).isRequired,
	text: PropTypes.string,
	searchString: PropTypes.string,
	value: PropTypes.any,
};
